import React from 'react'
import { Col, Typography } from 'antd'

const { Text } = Typography

interface InfoItem {
	title: string
	value: React.ReactNode
}

const PayslipInfoColumn: React.FC<InfoItem> = ({ title, value }) => (
	<Col span={12}>
		<Text type="secondary">{title}</Text>
		<br />
		<Text strong>{value}</Text>
	</Col>
)

export default PayslipInfoColumn
